// extracted by mini-css-extract-plugin
export default {"image":"M3-z","loaded":"N3-z"};